import { render, staticRenderFns } from "./PostPreviewInfo.vue?vue&type=template&id=1c351efe&scoped=true"
import script from "./PostPreviewInfo.vue?vue&type=script&lang=js"
export * from "./PostPreviewInfo.vue?vue&type=script&lang=js"
import style0 from "./PostPreviewInfo.vue?vue&type=style&index=0&id=1c351efe&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c351efe",
  null
  
)

export default component.exports